export enum PusherEventsEnum {
  ADMIN_SITE_CANCELS_DATA_UPDATED_EVENT = 'admin-site-cancels-data-updated-event',
  ADMIN_COMMISSION_PAYOUT_REQUEST_DATA_UPDATED_EVENT = 'admin-commission-payout-request-data-updated-event',
}
